import { Box, Stack, useTheme } from "@mui/material";
import { Breadcrumbs } from "src/components/Breadcrumb/Breadcrumbs.tsx";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext.tsx";
import { ScoreDetailTabs, Tabs } from "./InnerTabs/ScoreDetailTabs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ScoreCardHeader } from "@foodpilot/foods";

type ScoreDetailProps = {
    selectedTab: Tabs;
};
export const ScoreDetail = (props: ScoreDetailProps) => {
    const navigate = useNavigate();

    const { scoreDetail, drilldownState, tabConfig, scoreList } = useScoreDetailContext();

    useEffect(() => {
        if (props.selectedTab === null) {
            const entrypointUrl = tabConfig.distribution.link(scoreDetail.id);
            navigate(entrypointUrl);
        }
    }, []);

    return (
        <Stack>
            <Stack gap={1} mb={3}>
                <ScoreCardHeader
                    variant="primary"
                    selectedItemId={scoreList.lastSelected.rowId}
                    options={scoreList.scoresWithVariations.map((d) => ({ ...d, id: d.rowId }))}
                    orientation="horizontal"
                    extraStyle={{
                        noExtraSpacing: true,
                    }}
                />
                <Box display="flex">
                    <Breadcrumbs items={drilldownState.breadcrumbs} />
                </Box>
            </Stack>
            <ScoreDetailTabs selectedTab={props.selectedTab} />
        </Stack>
    );
};
